import React, {useState} from 'react';
import { Grid, Box, Typography, SxProps } from '@mui/material';
import { IGridCardItemProps, IGridSize } from './interfaces';
import { defaultGridSize } from './data';
import {Theme} from "@mui/system";

/**
 * @param icon The data that defines the actions
 * @param label
 * @param value
 * @param data
 * @param gridSize
 * @param onClick
 * @param labelStyles
 * @param valueStyles
 * @param elementStyleActive
 * @param elementStyles
 * @constructor
 * @deprecated
 */
const GridCardItem = ({
  label,
  value,
  data,
  listId,
  gridSize,
  onClick,
  labelStyles,
  valueStyles,
  elementStyleActive,
  elementStyles,
}: IGridCardItemProps) => {

  const itemGridSize: IGridSize = {
    ...defaultGridSize,
    ...gridSize,
  };

  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const defaultLabelStyles: SxProps<Theme> = {
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: '1em',
    fontWeight: 400,
    lineHeight: '1.5em',
    letterSpacing: '0.01em',
    fontFamily: 'Inter',
    textTransform: 'uppercase',
  };

  const defaultValueStyles: SxProps<Theme> = {
    ...defaultLabelStyles,
    color: 'rgba(0, 0, 0, 0.60)',
    textTransform: 'capitalize',
    wordWrap: 'break-word',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    transition: 'text-overflow 0.3s',
  };

  const handleClick = () => {
     onClick && onClick(data, listId);
  };

  return (
    <Grid xs={itemGridSize.xs} sm={itemGridSize.sm} md={itemGridSize.md} lg={itemGridSize.lg} item>
      <Box sx={{
          ...(elementStyleActive && {
            backgroundColor: '#fafafa',
            //p: 2,
            borderBottomLeftRadius: '0.4em',
            borderBottomRightRadius: '0.4em',
            ...elementStyles
          })
        }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <Typography variant='body1' sx={{
            ...defaultLabelStyles,
            ...(labelStyles && labelStyles),
          }}>
          {label}
        </Typography>
        {
          onClick ? (
            <Box sx={{ display: 'flex', gap: '0.5em' }}>
              {
                <Typography
                  component={'a'}
                  variant='body1'
                  sx={{
                    ...defaultLabelStyles,
                    ...(labelStyles && labelStyles),
                    color: '#3F51B5',
                    cursor: 'pointer',
                  }}
                  onClick={handleClick}
                >
                  {value ? value : '-'}
                </Typography>
              }
            </Box>
          ) : (
            <Typography
              sx={{
                ...defaultValueStyles,
                ...(valueStyles && valueStyles),
                textOverflow: isHovered ? 'unset' : 'ellipsis',
                whiteSpace: isHovered ? 'normal' : 'nowrap',
                transition: 'text-overflow 0.3s',
              }}
              variant='body2'
            >
              {value ? value : '-'}
            </Typography>
          )
        }
      </Box>
    </Grid>
  );
};

export default GridCardItem;